import React from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import Breadcrumb from "../components/Breadcrumb";
import AllBookings from "../components/AllBookings";

const AllBookingsPage = () => {

    return (

        <>
            {/* MasterLayout */}
            <MasterLayout>
                {/* Breadcrumb */}
                <Breadcrumb title='All Bookings' />

                <AllBookings />

            </MasterLayout>
        </>

    );

};

export default AllBookingsPage;
